import React, { useState } from "react";
import toast from "react-hot-toast";
import { Form, Input, Upload, Image } from "antd";
import ModalComponent from "../../../components/modals/ModalComponent";
import LoadableButton from "../../../components/buttons/LoadableButton";
import { UpdateProfileApi } from "../../../api/request/settings/settings";

const UpdateProfileModal = ({ client, setClient, isOpen, setIsOpen }) => {
  const [form] = Form.useForm();
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [fileList, setFileList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };

  const handleChange = ({ fileList: newFileList }) => {
    setFileList(newFileList);
    form.setFieldsValue({ profile_img: newFileList });
    if (!newFileList?.length) form.setFieldsValue({ profile_img: [] });
  };

  const UploadButton = (
    <button type="button" className="flex flex-col items-center gap-2">
      <div className="size-7">
        <img src="/assets/icons/upload.svg" alt="icon" />
      </div>
      Upload
    </button>
  );

  const handleSubmit = async (values) => {
    setIsLoading(true);
    try {
      if (values?.profile_img?.length) {
        values.profile_img = values?.profile_img[0]?.originFileObj;
      }
      const apiHeader = {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      };
      const params = { user_id: client?.id, ...values };
      const { data } = await UpdateProfileApi(params, apiHeader);
      if (data?.status) {
        toast.success(data?.message);
        setClient({ ...client, ...data?.data });
        if (data?.data?.image)
          setFileList([{ uid: "1", url: data?.data?.image, status: "done" }]);
        setIsOpen(false);
      }
    } catch (error) {
      if (error?.response?.data?.message)
        toast.error(error?.response?.data?.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <ModalComponent
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title="Update Profile"
      width={600}
    >
      <Form
        form={form}
        layout="vertical"
        size="large"
        autoComplete="off"
        initialValues={client}
        onFinish={handleSubmit}
      >
        <div>
          <Form.Item name="profile_img">
            <Upload
              beforeUpload={() => false}
              multiple
              listType="picture-card"
              fileList={fileList}
              onPreview={handlePreview}
              onChange={handleChange}
            >
              {fileList.length >= 1 ? null : UploadButton}
            </Upload>
          </Form.Item>
          {previewImage && (
            <Image
              wrapperStyle={{ display: "none" }}
              preview={{
                visible: previewOpen,
                onVisibleChange: (visible) => setPreviewOpen(visible),
                afterOpenChange: (visible) => !visible && setPreviewImage(""),
              }}
              src={previewImage}
            />
          )}
        </div>

        <div className="grid lg:grid-flow-col gap-4">
          <div>
            <label className="text-base font-medium">First Name</label>
            <Form.Item
              name="first_name"
              rules={[{ required: true, message: "Please enter first name." }]}
            >
              <Input placeholder="First name" />
            </Form.Item>
          </div>
          <div>
            <label className="text-base font-medium">Last Name</label>
            <Form.Item
              name="last_name"
              rules={[{ required: true, message: "Please enter last name." }]}
            >
              <Input placeholder="Last name" />
            </Form.Item>
          </div>
        </div>

        <div className="grid lg:grid-flow-col gap-4">
          <div>
            <label className="text-base font-medium">Phone 1</label>
            <Form.Item
              name="mobile_no"
              rules={[
                { required: true, message: "Please enter phone number" },
                {
                  pattern: /^[0-9]{10}$/,
                  message: "Phone number must be 10 digits",
                },
              ]}
            >
              <Input type="number" placeholder="Enter phone 1" />
            </Form.Item>
          </div>
          <div>
            <label className="text-base font-medium">Phone 2</label>
            <Form.Item
              name="mobile_no2"
              rules={[
                {
                  pattern: /^[0-9]{10}$/,
                  message: "Phone number must be 10 digits",
                },
              ]}
            >
              <Input type="number" placeholder="Enter phone 2" />
            </Form.Item>
          </div>
        </div>

        <div className="grid lg:grid-flow-col gap-4">
          <div>
            <label className="text-base font-medium">SIN Number</label>
            <Form.Item name="sin_number">
              <Input type="number" placeholder="Enter SIN number" />
            </Form.Item>
          </div>

          <div>
              <label className='text-base font-medium'>Spouse Email</label>
              <Form.Item name="spouse_email">
                  <Input placeholder="spouse email" />
              </Form.Item>
          </div>
        </div>

        <LoadableButton
          className="bg-primary text-white uppercase text-base font-semibold py-2 rounded-lg px-8 mt-5"
          type="submit"
          lable="Update"
          isLoading={isLoading}
          loadingLable="Updating profile..."
        />
      </Form>
    </ModalComponent>
  );
};

export default UpdateProfileModal;
